import { SEARCH_PAGE_CHECK_REQUEST, SEARCH_PAGE_CHECK_REQUEST_API_ERROR, SEARCH_PAGE_CHECK_REQUEST_SUCCESS } from "./ActionTypes";


  //search page check
  export const searchPageCheckRequest = (values, loginDetail) => {
    return {
      type: SEARCH_PAGE_CHECK_REQUEST,
      payload: {values, loginDetail}
    };
  };

  export const searchPageCheckRequestSuccess = data => {
    return {
      type: SEARCH_PAGE_CHECK_REQUEST_SUCCESS,
      payload: data,
    };
  };
  
  export const searchPageCheckRequestApiError = error => {
    return {
      type: SEARCH_PAGE_CHECK_REQUEST_API_ERROR,
      payload: error,
    };
  };


  